
// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import { cryptoTopupStatuses, riskLevels } from '../statuses';

export default class CryptoTopupsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'crypto-topups';
        this.Server = this.props.context.getState().server.cryptoTopups;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'hash'];

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'walletId',
                label: 'wallet',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletWallets',
                object: 'wallet',
                show: 'uuid'
            },
            {
                id: 'cryptoTokenId',
                label: 'cryptoToken',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'cryptoTokens',
                object: 'cryptoToken',
                show: 'name'
            },
            {
                id: 'cryptoAmount',
                label: 'cryptoAmount',
                alignRight: true,
                cell: 'CryptoAmount',
                displayGrid: true
            },
            {
                id: 'accountAmount',
                label: 'accountAmount',
                alignRight: true,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'senderWalletAddress',
                label: 'senderWalletAddress',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                disableEditor: true,
                items: Object.values(cryptoTopupStatuses)
            },
            {
                id: 'riskLevel',
                label: 'riskLevel',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                disableEditor: true,
                items: Object.values(riskLevels)
            },
            {
                id: 'hash',
                label: 'hash',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'accountTxId',
                label: 'accountTxId',
                alignRight: false,
                cell: 'Text',
                displayGrid: false
            },
            {
                id: 'amlData',
                label: 'amlData',
                alignRight: false,
                cell: 'Json',
                displayGrid: false,
                disableEditor: true,
                displayDialogDetails: true,
                details: 'Json'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

